module.exports = __webpack_public_path__ + "static/IMG_2894.c980e8ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hair-color/IMG_2894.jpg
// module id = 502
// module chunks = 255811786354371